import { isBlob, isFile } from "../helpers"

const FormDataMixin = {
	methods: {
		buildFormData(fields, exclude = [], dropEmpty = true) {
			const formData = new FormData()

			for (let [key, value] of Object.entries(fields)) {
				if (exclude.includes(key)) {
					continue
				}
				if (dropEmpty && (value === null || typeof value === 'undefined')) {
					continue
				}
				if (Array.isArray(value)) {
					value.forEach((item, index) => {
						formData.append(`${key}[${index}]`, this.stringifyObject(item))
					})
					continue
				}
				formData.append(key, value ? this.stringifyObject(value) : value)
			}

			return formData
		},
		debugFormData(formData) {
			console.log('-- FORM DATA CONTENT --')
			for (let [key, value] of formData.entries()) {
				console.log(key, value)
			}
			console.log('-- END OF FORM DATA CONTENT --')
		},
		stringifyObject(item) {
			if (isBlob(item) || isFile(item)) {
				return item
			}
			if (typeof item === 'object') {
				return JSON.stringify(item)
			}
			return item
		},
	}
}

export default FormDataMixin
